export const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000/api';

export const ROUTES = {
  LOGIN: '/login',
  DASHBOARD: '/',
  COMPANIES: '/companies',
  COMPANY_DETAIL: '/companies/:id',
  USERS: '/users',
  MACHINES: '/machines',
  MACHINE_DETAIL: '/machines/:id',
  PRODUCTS: '/products',
  TRANSACTIONS: '/transactions',
  SESSIONS: '/sessions',
  REVENUE: '/revenue',
  SETTINGS: '/settings',
} as const;

export const DEFAULT_PAGINATION = {
  page: 1,
  limit: 20,
  sortBy: 'createdAt',
  sortOrder: 'desc' as const,
};

export const STATUS_COLORS = {
  online: 'bg-success/10 text-success',
  offline: 'bg-danger/10 text-danger',
  active: 'bg-success/10 text-success',
  inactive: 'bg-muted text-muted-foreground',
  completed: 'bg-success/10 text-success',
  failed: 'bg-danger/10 text-danger',
  pending: 'bg-warning/10 text-warning',
  cancelled: 'bg-muted text-muted-foreground',
  expired: 'bg-muted text-muted-foreground',
} as const;

export const USER_ROLES = {
  SUPER_ADMIN: 'SUPER_ADMIN',
  COMPANY_ADMIN: 'COMPANY_ADMIN',
  COMPANY_OPERATOR: 'COMPANY_OPERATOR',
  CONSUMER: 'CONSUMER',
} as const;

export const ROLE_LABELS: Record<string, string> = {
  SUPER_ADMIN: 'Super Admin',
  COMPANY_ADMIN: 'Admin kompanije',
  COMPANY_OPERATOR: 'Operator',
  CONSUMER: 'Korisnik',
};
